var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoingecko(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "166px",
    height: "166px",
    viewBox: "0 0 48.00 48.00",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 3.072,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-linejoin:round;}.b{fill:#FFFFFF;}")), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 24,
    cy: 24,
    r: 21.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.051,37.2278C11.57,27.8692,8.8785,15.757,16.1682,13.8505s12.0561,1.3458,15.8692,2.4673,6.979,1.7158,7.6822,5.271C40.729,26.6916,24.1308,35.71,27.6636,45.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.3551,26.972c3.1963,2.5233,6.4961,1.6849,13.7957-1.3734"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M29.8489,15.5366c0-2.273-4.148-4.0973-6.7189-2.0786"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 21.0467,
    cy: 19.1215,
    r: 3.3084
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 21.0467,
    cy: 19.1215,
    r: 1.2897
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 34.8411,
    cy: 22.9907,
    r: 0.775
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M42.3747,22.9906A18.4041,18.4041,0,0,0,25.0332,5.6266"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoingecko);
export default __webpack_public_path__ + "static/media/coingecko.6df48c20b7793236cf7237f12c284341.svg";
export { ForwardRef as ReactComponent };